import { MarketplaceBankingSubProductTypeEnum } from '@repo/supergraph-schemas/marketplace/enums';

const BANKING_ICONS_CDN_BASE = 'https://www.nerdwallet.com/cdn/banking/icons';

export const MARKETPLACE_BANKING_SUBPRODUCT_NAV_LABELS: Record<
  MarketplaceBankingSubProductTypeEnum,
  string
> = {
  [MarketplaceBankingSubProductTypeEnum.CHECKING]: 'Checking Account',
  [MarketplaceBankingSubProductTypeEnum.SAVINGS]: 'Savings Account',
  [MarketplaceBankingSubProductTypeEnum.MONEY_MARKET]: 'Money Market Account',
  [MarketplaceBankingSubProductTypeEnum.PREMIUM_MONEY_MARKET]: 'Money Market Account',
  [MarketplaceBankingSubProductTypeEnum.CD]: 'Certificates of Deposit',
  [MarketplaceBankingSubProductTypeEnum.PREPAID]: 'Prepaid Account',
  [MarketplaceBankingSubProductTypeEnum.CASH_MANAGEMENT]: 'Cash Management Account',
};

export const MARKETPLACE_BANKING_SUBPRODUCT_ICONS: Record<
  MarketplaceBankingSubProductTypeEnum,
  string
> = {
  [MarketplaceBankingSubProductTypeEnum.SAVINGS]: `${BANKING_ICONS_CDN_BASE}/savings-icon.svg`,
  [MarketplaceBankingSubProductTypeEnum.CHECKING]: `${BANKING_ICONS_CDN_BASE}/checking-icon.svg`,
  [MarketplaceBankingSubProductTypeEnum.MONEY_MARKET]: `${BANKING_ICONS_CDN_BASE}/money-market-icon.svg`,
  [MarketplaceBankingSubProductTypeEnum.PREMIUM_MONEY_MARKET]: `${BANKING_ICONS_CDN_BASE}/money-market-icon.svg`,
  [MarketplaceBankingSubProductTypeEnum.CD]: `${BANKING_ICONS_CDN_BASE}/certificate-of-deposit-icon.svg`,
  [MarketplaceBankingSubProductTypeEnum.CASH_MANAGEMENT]: `${BANKING_ICONS_CDN_BASE}/cash-management-icon.svg`,
  [MarketplaceBankingSubProductTypeEnum.PREPAID]: `${BANKING_ICONS_CDN_BASE}/prepaid-icon.svg`,
};

export const getBankingProductAnchorId = (subProduct: MarketplaceBankingSubProductTypeEnum) =>
  `banking-product--${subProduct.toLowerCase().replace(/_/g, '-')}`;
